import { PropsWithChildren } from "react";
import { Navigate, useParams } from "react-router";
import { queryClient } from "../App";

const PrivateRouteCheck = ({ children }: PropsWithChildren) => {
  const params = useParams();
  const staffAuthData = queryClient.getQueryData(["auth-user"]);

  if (!staffAuthData) {
    return (
      <Navigate to={`${process.env.PUBLIC_URL}/${params.hotelcode}/login`} />
    );
  }

  return children;
};

export default PrivateRouteCheck;
